import { TRootState } from "../@types"

export const selectModalDiscountCode = ( state: TRootState ) =>state.discountCode.discountCodeModalIsOpen

export const selectIsUpdateDiscountCode = ( state: TRootState ) =>state.discountCode.isUpdateDiscountCode

export const selectDiscountCodeForUpdate = ( state: TRootState ) =>state.discountCode.discountCodeForUpdate

export const selectDiscountCodeRefreshTable =  ( state: TRootState ) =>state.discountCode.refreshTableDiscountCode